<template>
  <div id="company">
    <div class="title"><span>了解更多</span></div>
    <div class="item item_1">
      <div class="col_1">
        <img src="../../assets/images/icon_phone.png" alt="" />
        <span class="col_phone_title"> 客服热线 </span>
        <span class="col_phone">17805606905</span>
      </div>
      <p>人工客服时间：上午9:00 - 下午6:00</p>
    </div>
    <div class="item item_2">
      <div class="col_1">
        <img src="../../assets/images/icon_map.png" alt="" />
        <span class="col_phone_title"> 公司地址 </span>
      </div>
      <p>安徽省 合肥市 经开区 天都路129号</p>
    </div>
    <div class="item item_3">
      <div class="col_left">
        <div class="col_1">
          <img src="../../assets/images/icon_minus.png" alt="" />
          <span class="col_phone_title"> 官方公众号 </span>
        </div>
        <p>关注公众号</p>
        <p>掌握最新展会信息</p>
      </div>
      <img class="wx_code" src="../../assets/images/code.png" />
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
#company {
  padding: 16px;
  .item {
    width: 343px;
    height: 110px;
    box-sizing: border-box;
    border-radius: 7px;
    margin-bottom: 12px;
    background: #fff url("../../assets/images/bg_3.png") no-repeat;
    background-size: cover;
    padding-left: 40px;
    display: flex;
    p {
      padding-left: 28px;
    }
  }
  .col_1 {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 14px;
    color: #666666;
    .col_phone_title {
      font-size: 18px;
      color: #000000;
      margin-right: 8px;
    }
    .col_phone {
      font-weight: bold;
      font-size: 18px;
      color: #0068b7;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .item_1 {
    flex-direction: column;
    justify-content: center;
  }
  .item_2 {
    flex-direction: column;
    background: #fff url("../../assets/images/bg_4.png") no-repeat;
    justify-content: center;
    background-size: cover;
  }
  .item_3 {
    height: 168px;
    background: #fff url("../../assets/images/bg_5.png") no-repeat;
    background-size: cover;
    align-items: center;
    .wx_code {
      width: 110px;
      height: 110px;
      margin-left: 40px;
    }
    p {
      margin-bottom: 4px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #0068b7;
    position: relative;
    margin-bottom: 50px;
    span {
      position: absolute;
      z-index: 2;
    }
  }
  .title::after {
    content: "DISPLAY";
    position: absolute;
    font-weight: bold;
    font-size: 18px;
    color: #efefef;
    top: 1px;
    z-index: 1;
  }
  .title::before {
    content: "";
    width: 86px;
    height: 3px;
    background: #0068b7;
    position: absolute;
    top: 24px;
  }
}
</style>